import RegisterNewUserPage from "./RegisterNewUserPage";

export default RegisterNewUserPage;

export * from "./RegisterNewUserPage";
